import React from "react";
import styles from "./index.module.css";

/**
 * Action bar to hold form buttons, aligned to the right.
 */
export function FormActionBar({ children }) {
  return <div className={styles.container}>{children}</div>;
}
